var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import cxs from 'cxs/component';
import { inject } from 'mobx-react';
import theme from '../../Theme';
import OperationLinesContainer from './container/OperationLinesContainer';
import StretchesPacketsContainer from '../Stretches/container/StretchesPacketsContainer';
let Index = class Index extends Component {
    constructor(props) {
        super(props);
        props.store.operationLines.read();
        props.store.businessUnits.read();
        // props.store.receiptLayouts.read()
    }
    render() {
        return (React.createElement(Wrapper, { style: {
                marginBottom: theme.common.size.bar,
            } },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/operationlines", component: OperationLinesContainer }),
                React.createElement(Route, { exact: true, path: "/operationlines/:id", component: props => React.createElement(StretchesPacketsContainer, Object.assign({}, props)) }))));
    }
};
Index = __decorate([
    inject('store')
], Index);
export default Index;
const Wrapper = cxs('div')({
    height: '100%',
    overflow: 'auto'
});



//////////////////
// WEBPACK FOOTER
// ./src/modules/OperationLines/index.tsx
// module id = 537
// module chunks = 0